import React, { useEffect, useState } from 'react';
import {
  View,
  Text,
  StyleSheet,
  Image,
  TouchableOpacity,
  ScrollView,
  Modal,
  Platform,
} from 'react-native';
import { toast } from 'react-toastify';
import CheckIcon from '../../assets/tickmark.png';

const SelectKidsModal = ({
  visible,
  title = 'Select Kid(s)',
  kids = [],
  initialSelectedIds = [],
  maxKids,
  pricePerMonth,
  onConfirm,
  onClose,
  onAddKid,
}) => {
  const [selectedIds, setSelectedIds] = useState(initialSelectedIds);

  useEffect(() => {
    if (visible) {
      setSelectedIds(initialSelectedIds);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  const toggleKid = id => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter(kidId => kidId !== id));
    } else if (maxKids && selectedIds.length >= maxKids) {
      toast.warn(`Please select ${maxKids} kid(s), as per plan you selected`);
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };

  const handleConfirm = () => {
    if (selectedIds.length === 0) {
      toast.info('Please select at least one kid');
      return;
    }
    onConfirm(kids.filter(kid => selectedIds.includes(kid.id)));
  };

  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={visible}
      onRequestClose={onClose}>
      <View style={styles.modalContainer}>
        <TouchableOpacity style={StyleSheet.absoluteFill} activeOpacity={1} onPress={onClose} />
        <View style={styles.modalContent}>
          <Text style={styles.modalTitle}>{title}</Text>

          <ScrollView style={styles.kidList} showsVerticalScrollIndicator={false}>
            {kids.map(kid => {
              const isSelected = selectedIds.includes(kid.id);
              return (
                <TouchableOpacity
                  key={kid.id}
                  style={styles.kidItem}
                  onPress={() => toggleKid(kid.id)}>
                  <Image
                    source={
                      kid.profilePic ? { uri: kid.profilePic } : require('../../assets/AddKidPic.png')
                    }
                    style={styles.kidImage}
                  />
                  <View style={styles.kidInfo}>
                    <Text style={styles.kidName}>{kid.name}</Text>
                    <Text style={styles.kidDetails}>
                      {`${kid.age} years, ${kid.gender === 'BOY' ? 'Boy' : 'Girl'}`}
                    </Text>
                  </View>
                  {isSelected && <Image source={CheckIcon} style={styles.checkIcon} />}
                </TouchableOpacity>
              );
            })}
          </ScrollView>

          {pricePerMonth != null && (
            <Text style={styles.totalText}>
              Total: ${pricePerMonth}/month ({selectedIds.length} kid
              {selectedIds.length === 1 ? '' : 's'} selected)
            </Text>
          )}

          <View style={styles.buttonContainer}>
            {onAddKid && (
              <TouchableOpacity style={styles.addButton} onPress={onAddKid}>
                <Text style={styles.addButtonText}>Add New Kid</Text>
              </TouchableOpacity>
            )}
            <TouchableOpacity style={styles.addButton} onPress={handleConfirm}>
              <Text style={styles.addButtonText}>Confirm Selection</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.5)',
  },
  modalContent: {
    width: '90%',
    maxWidth: 500,
    maxHeight: '85%',
    padding: 20,
    backgroundColor: '#fff',
    borderRadius: 10,
  },
  modalTitle: {
    fontSize: 18,
    marginBottom: 16,
    fontFamily: Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
    textAlign: 'center',
    fontWeight: 'bold',
    color: '#333',
  },
  kidList: {
    flexGrow: 0,
  },
  kidItem: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 12,
    marginBottom: 8,
    backgroundColor: '#f9f9f9',
    borderRadius: 8,
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
    justifyContent: 'space-between',
  },
  kidImage: {
    width: 50,
    height: 50,
    borderRadius: 25,
    marginRight: 12,
  },
  kidInfo: {
    flex: 1,
  },
  kidName: {
    fontSize: 18,
    fontFamily: Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
    fontWeight: 'bold',
  },
  kidDetails: {
    fontSize: 14,
    fontFamily: Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
    color: '#666',
  },
  checkIcon: {
    width: 20,
    height: 20,
    margin: 2,
  },
  totalText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#8dc63f',
    textAlign: 'center',
    marginTop: 12,
    fontFamily: Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
  buttonContainer: {
    alignItems: 'center',
    marginTop: 16,
  },
  addButton: {
    backgroundColor: '#A3D900',
    paddingVertical: 16,
    paddingHorizontal: 24,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    width: '60%',
    marginBottom: 12,
  },
  addButtonText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#fff',
    fontFamily: Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
  },
});

export default SelectKidsModal;
